import React, { useMemo, useContext } from 'react';
import classnames from 'classnames';
import { trailingSlash } from '../../../utils';
import GlobalContext from '../../../context/global';
import SendGridLink from '../../SendGridLink';
import { StyledMenuItem } from './styles';

const MenuLink = ({ url, label }) => {
  return (
    <StyledMenuItem>
      <SendGridLink to={url} dangerouslySetInnerHTML={{ __html: label }} />
    </StyledMenuItem>
  );
};

export default MenuLink;
